import { render } from "./CarouselPage.vue?vue&type=template&id=0bd96a1e&ts=true"
import script from "./CarouselPage.vue?vue&type=script&lang=ts"
export * from "./CarouselPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__